import axios from 'axios';

import { SORTORDER } from 'RestAPIs/endpoints';

export type CostCenterSortorder = {
  costCenterId: number;
  referenceDate: string;
};

export type CostCenterSortorderValues = {
  empId: number;
  empBrName: string;
  empBrId: number;
  contract_type: string;
  waId: number;
  functionId: number;
  empName: string;
  percentage: number;
  waNr: number;
  functionDescription: string;
  sortorder: number;
  weekHoursMin: number;
  benefit_id: number;
  contractTypeName: string;
};

export const getCostCenterSortorder = ({
  costCenterId,
  referenceDate
}: CostCenterSortorder) => {
  return axios.get<CostCenterSortorderValues[]>(
    `${SORTORDER}?referenceDate=${referenceDate}`,
    {
      pathParams: { costCenterId }
    }
  );
};

export const updateCostCenterSortorder = async ({
  sortorder,
  waId,
  costCenterId
}: {
  sortorder: number;
  waId: number;
  costCenterId: number;
}) => {
  return axios.put(
    `${SORTORDER.replace(':costCenterId', String(costCenterId))}`,
    {
      sortorder,
      waId
    }
  );
};
